(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[521],{

/***/ 6403:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(1255);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ about; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-seo@5.1.0_61390be992b634a688f7c2555547b55b/node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(6351);
// EXTERNAL MODULE: ./src/ui/components/LocationInfo/index.tsx + 1 modules
var LocationInfo = __webpack_require__(5119);
// EXTERNAL MODULE: ./src/ui/components/custom/Link/index.tsx
var Link = __webpack_require__(5879);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/styles/about/index.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n padding: 2vh 2vw;\n border-top: 1px solid #ddd;\n\n section {\n  h4 {\n   font-variant: small-caps;\n   font-stretch: 110%;\n   color: #f70;\n  }\n\n  @media (max-width: 426px) {\n   padding: 2vh 4vw 3vh;\n\n   h4 {\n    margin-bottom: 1vh;\n   }\n\n   > a,\n   p {\n    text-align: unset;\n   }\n\n   li + li {\n    margin-top: 0.5vh;\n   }\n  }\n\n  > a,\n  p {\n   line-height: 1.5;\n  }\n\n  ol {\n   margin-top: 1.5vh;\n  }\n\n  & + section {\n   margin-top: 3vh;\n  }\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Styling = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82a796c9-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/pages/about/index.tsx





var description = 'Informa\xe7\xf5es sobre a Revista Aufkl\xe4rung.';
var title = 'Sobre a revista';
var About = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                description: description,
                openGraph: {
                    description: description,
                    title: title
                },
                title: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationInfo/* default */.Z, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Styling, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Foco e Escopo"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Aufkl\xe4rung, revista de filosofia"
                                    }),
                                    " (Qualis B1, DOI 10.18012/ARF), tem foco na publica\xe7\xe3o de artigos na \xe1rea de filosofia, ou que sejam relevantes para a pesquisa na mesma. Tem como objetivos: contribuir para a forma\xe7\xe3o acad\xeamica de profissionais de filosofia e \xe1reas afins; contribuir para a efetiva\xe7\xe3o de pol\xedticas na \xe1rea de filosofia, ao propiciar a divulga\xe7\xe3o de resultados originados a partir de pesquisas filos\xf3ficas voltadas para a p\xf3s-gradua\xe7\xe3o com base em princ\xedpios \xe9ticos transparentes; e constituir-se como um espa\xe7o p\xfablico para o debate entre pesquisadores do Brasil e do exterior."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "A Revista Aufkl\xe4rung adota o processo de revis\xe3o cega pelos pares (double blind peer review) e tem como base revisores especializados a partir da base de Curr\xedculos da Plataforma Lattes, preferencialmente membros ligados \xe0 p\xf3s-gradua\xe7\xe3o na \xe1rea. Ela \xe9 editada pelo Grupo de Pesquisa Teoria Cr\xedtica e Hermen\xeautica (GPTeCH/CNPq/UFPB)."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "\xc1rea da Revista: Filosofia [70100004 CAPES/CNPq]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Processo de Avalia\xe7\xe3o pelos Pares"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Essa revista \xe9 \"peer reviewed\", e segue o processo de avalia\xe7\xe3o cega (double blind review) por pares. Nesse processo, o artigo \xe9 avaliado por dois avaliadores, tendo em vista o cumprimento das pol\xedticas editoriais da revista, em geral, e das pol\xedticas de sess\xf5es, em particular. O artigo enviado ao avaliador \xe9 tornado cego, impossibilitando qualquer identifica\xe7\xe3o por meio eletr\xf4nico, e submetido pelo sistema interno ou por email para 2 avaliadores especialistas na \xe1rea tem\xe1tica do artigo. O resultado pode ser \"aprovado\", \"reprovado\" e \"aprovado com modifica\xe7\xf5es obrigat\xf3rias/sugeridas\". Em caso de empate no resultado, o artigo \xe9 submetido a um terceiro avaliador para dirimir a d\xfavida. Com base no resultado da avalia\xe7\xe3o cega, a revista decide pela publica\xe7\xe3o ou n\xe3o do artigo, considerando os itens de de originalidade, relev\xe2ncia e m\xe9rito cient\xedfico especificamente dentro da \xe1rea de atua\xe7\xe3o da revista, podendo sugerir agendamentos, em caso de aprova\xe7\xe3o, para edi\xe7\xf5es futuras. Artigos de autores convidados n\xe3o s\xe3o avaliados pelo sistema de avalia\xe7\xe3o cega. Submiss\xf5es reprovadas n\xe3o poder\xe3o ser submetidas uma segunda vez \xe0 revista."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Periodicidade"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Periodicidade: Quadrimestral (2017)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Data das edi\xe7\xf5es: Abril, Agosto e Dezembro"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Fluxo de submiss\xe3o de artigos: cont\xednuo"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "*Adicionalmente, a qualquer tempo poder\xe3o ser lan\xe7ados n\xfameros tem\xe1ticos, a crit\xe9rio da revista, e/ou a cargo de editores especiais, oriundos de eventos de express\xe3o acad\xeamica que justifiquem a edi\xe7\xe3o."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Pol\xedtica de Acesso Livre"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Esta revista oferece acesso livre imediato ao seu conte\xfado, seguindo o princ\xedpio de que disponibilizar gratuitamente o conhecimento cient\xedfico ao p\xfablico proporciona maior democratiza\xe7\xe3o mundial do conhecimento. A Aufkl\xe4rung oferece acesso livre e irrestrito aos usu\xe1rios, n\xe3o necessitando de cadastro pr\xe9vio para leituras dos conte\xfados publicados. Ela \xe9 regida por uma licen\xe7a",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://creativecommons.org/licenses/by/4.0/",
                                        children: "Creative Commons Attribution 4.0 International (CC BY 4.0)"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Exchanges"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                href: "http://www.ojs.ufpi.br/index.php/pensando/issue/current/showToc",
                                                children: "PENSANDO: Revista de Filosofia"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Mestrado em \xc9tica e Epistemologia da UFPI"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "ISSN 2178-843X"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                href: "http://www.revistaclareira.com.br/index.php/clareira/index",
                                                children: "CLAREIRA: Revista de Filosofia da Regi\xe3o Amaz\xf4nica"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Departamento de Filosofia da Universidade Federal de Rond\xf4nia"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "ISSN 2359-1951"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Taxas de publica\xe7\xe3o (APCs)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Esta revista declara open-access aos seus conte\xfados imediatamente para uso do p\xfablico em geral. Open access n\xe3o significa \"produ\xe7\xe3o livre de custos\". Ent\xe3o, tenha em mente que alguns trabalham para que o conte\xfado seja disponibilizado gratuitamente para a comunidade em geral."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "N\xe3o obstante os custos envolvidos no processo de produ\xe7\xe3o geral da revista, declaramos que todo o processo de submiss\xe3o ocorre de forma gratuita para os autores e nenhuma taxa \xe9 cobrada em qualquer parte do processo de publica\xe7\xe3o dentro de seus prazos normais de avalia\xe7\xe3o."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Nota"
                                    }),
                                    ": Os prazos para avalia\xe7\xe3o de artigos submetidos duram, em m\xe9dia, 6 semanas, dado que trabalhamos com inteira m\xe3o de obra especializada de forma gratuita e de boa vontade dos contribuidores. Se autores ou institui\xe7\xf5es, entretanto, desejam prazos menores para avalia\xe7\xe3o de artigos, taxas podem ser cobradas com o \xfanico e exclusivo fim de tornar o processo avaliativo menor. Contate o editor para cota\xe7\xe3o."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Pol\xedtica contra pl\xe1gio"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Esta revista adere ao sistema ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "http://www.ithenticate.com/",
                                        children: "iThenticate"
                                    }),
                                    " para verificar a autenticidade dos manuscritos a ela submetidos."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "\xc9tica na Publica\xe7\xe3o e Boas Pr\xe1ticas"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "A qualidade dos artigos depende diretamente do emprego de padr\xf5es \xe9ticos e boas pr\xe1ticas para a publica\xe7\xe3o acad\xeamica. A Revista Aufkl\xe4rung est\xe1 comprometida com o uso de padr\xf5es internacionais em todas as etapas do processo de publica\xe7\xe3o. Autores, Editores, Avaliadores, Editoras s\xe3o obrigados a seguir as Boas Pr\xe1ticas na Publica\xe7\xe3o, evitando pr\xe1ticas de pl\xe1gio, autopl\xe1gio, publica\xe7\xf5es fantasmas, difama\xe7\xe3o e viola\xe7\xe3o de direitos autorais, em quaisquer n\xedveis ou quantidades, detectados em qualquer etapa do processo de publica\xe7\xe3o."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Com o objetivo de resguardar os direitos de avaliadores, autores e institui\xe7\xf5es envolvidas no processo de publica\xe7\xe3o, a avalia\xe7\xe3o dos manuscritos submetidos \xe9 regida pelos seguintes princ\xedpios: impessoalidade, imparcialidade, transpar\xeancia e confidencialidade."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Por estar indexada no DOAJ, declaramos que a Revista Aufkl\xe4rung segue, de forma ampla e irrestrita, todos os",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://doaj.org/bestpractice",
                                        children: "princ\xedpios e boas pr\xe1ticas estabelecidos pelo DOAJ"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Declaramos, publicamente, que somos membros do Sistema CrossRef, e aderimos ao uso da m\xe1quina antipl\xe1gio iThenticate."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Conflito de Interesses"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "A Revista Aufkl\xe4rung, no cumprimento das Boas Pr\xe1ticas na Publica\xe7\xe3o, solicita aos Consultores que, ao receber um manuscrito para avalia\xe7\xe3o, verifiquem se ocorre qualquer uma das situa\xe7\xf5es abaixo que definem um conflito de interesse. Caso ocorra, solicitamos que nos seja comunicado sobre a impossibilidade de emitir o parecer solicitado. Situa\xe7\xf5es que caracterizam um conflito de interesse:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "houve colabora\xe7\xe3o com o autor na elabora\xe7\xe3o do trabalho submetido, ou em atividades de pesquisa (Ex.: Participam do mesmo Grupo) que resultaram na elabora\xe7\xe3o do manuscrito;"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "trata-se de rela\xe7\xe3o de afinidade do tipo orientador/orientado(a);"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "existe algum interesse na publica\xe7\xe3o para fins de promo\xe7\xe3o pessoal, institucional ou comercial;"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "existe alguma rela\xe7\xe3o familiar ou afetiva com o autor/es do trabalho;"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "qualquer outra situa\xe7\xe3o que possa caracterizar impedimento para a emiss\xe3o de um parecer neutro para o manuscrito."
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Classifica\xe7\xe3o Qualis Capes / Brasil"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "CLASSIFICA\xc7\xc3O CAPES/BRASIL"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "\xc1rea de classifica\xe7\xe3o da Revista (Principal): ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Filosofia [70100004 CAPES/CNPq]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Classifica\xe7\xe3o 2013-2016: ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "B1"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Outras \xe1reas: Favor consultar a Plataforma Sucupira, se\xe7\xe3o",
                                    ' ',
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://sucupira.capes.gov.br/sucupira/public/consultas/coleta/veiculoPublicacaoQualis/listaConsultaGeralPeriodicos.jsf",
                                        children: "Qualis"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Sponsors"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Esta Revista foi editada inteiramente com recursos pr\xf3prios at\xe9 a data de [Junho de 2017], com hospedagem disponibilizada pelo Servidor Central da UFPB."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "EM 2017/18 recebe apoio financeiro de n\xfamero [441153/2017-8], pela Chamada CNPq/CAPES No 26/2017 – Programa Editorial\":"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "Conselho Nacional de Desenvolvimento Cient\xedfico e Tecnol\xf3gico - CNPq (2017/18)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Visit at: ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: "http://www.cnpq.br/",
                                                        children: "cnpq.br"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Nota: Em Julho/2019 o Recurso ainda n\xe3o foi empenhado"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: "Coordena\xe7\xe3o de Aperfei\xe7oamento de Pessoal de N\xedvel Superior - CAPES"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "Visit at: ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: "http://www.capes.gov.br/",
                                                        children: "capes.gov.br"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var about = (About);


/***/ }),

/***/ 5119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LocationInfo; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4637);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.0.10_react-dom@17.0.2+react@17.0.2/node_modules/next/router.js
var router = __webpack_require__(1999);
// EXTERNAL MODULE: ./src/ui/components/custom/Link/index.tsx
var Link = __webpack_require__(5879);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.3_281a4fa50a045c9112baf635f3bc27a7/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9306);
;// CONCATENATED MODULE: ./src/ui/components/LocationInfo/styles.ts

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n font-size: 0.9em;\n margin: 2vh 2vw;\n\n @media (max-width: 462px) {\n  margin: 2vh 4vw;\n }\n\n span:last-of-type {\n  color: #f70;\n }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba06a0ec-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/ui/components/LocationInfo/index.tsx




var LocationInfo = function(param) {
    var children = param.children;
    var pathname = (0,router.useRouter)().pathname;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: "/",
                children: "In\xedcio"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: " / "
            }),
            pathname.match(/\/issues.+/) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "/issues",
                    children: "Arquivos / "
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            })
        ]
    }));
};
/* harmony default export */ var components_LocationInfo = (LocationInfo);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [522,888,179], function() { return __webpack_exec__(6403); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);